import { motion } from 'framer-motion';
import { ENTITY_BAR } from '@/data/cctsData';

export const EntityShareBar = () => {
  const total = ENTITY_BAR.reduce((s, e) => s + e.count, 0);
  return (
    <div data-testid="entity-share-bar">
      <p className="font-mono text-xs text-gray-400 uppercase tracking-[0.15em] mb-4">Entity-Count Share — 8 Finalized Sub-Sectors</p>
      {/* Stacked bar */}
      <div className="flex h-10 rounded-xl overflow-hidden mb-6">
        {ENTITY_BAR.map((e, i) => (
          <motion.div
            key={i}
            initial={{ width: 0 }}
            whileInView={{ width: `${(e.count / total) * 100}%` }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08, duration: 0.5 }}
            style={{ backgroundColor: e.color }}
            className="relative group cursor-default"
          >
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 bg-brand-dark text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10 font-mono shadow-lg">
              {e.name}: {e.count}
            </div>
          </motion.div>
        ))}
      </div>
      {/* Legend */}
      <div className="grid grid-cols-2 gap-x-8 gap-y-3">
        {ENTITY_BAR.map((e, i) => (
          <div key={i} className="flex items-center gap-3">
            <span className="w-4 h-4 rounded flex-shrink-0" style={{ backgroundColor: e.color }} />
            <span className="font-sans text-sm text-gray-600">{e.name}</span>
            <span className="font-mono text-lg text-gray-800 font-bold ml-auto">{e.count}</span>
          </div>
        ))}
      </div>
      <p className="font-mono text-xs text-gray-400 mt-4">Draft sectors (steel, fertiliser) excluded from this share.</p>

      {/* 358.6 callout */}
      <div className="mt-6 bg-white border border-gray-200 rounded-xl p-6 flex items-center gap-6">
        <div className="flex-shrink-0">
          <span className="font-serif text-5xl text-brand-brown font-bold">358.6</span>
          <span className="font-sans text-base text-gray-500 ml-1.5">MtCO₂e</span>
        </div>
        <p className="font-sans text-base text-gray-600">
          Iron & steel alone adds roughly <strong className="text-brand-brown">half the scheme's total footprint</strong> once finalized.
        </p>
      </div>
    </div>
  );
};
